import React, { Component } from 'react';
import { Col, FormControl, FormGroup, Row } from 'react-bootstrap';
import './styles.scss';

const FormControlStatic = FormControl.Static;

export default class Endorsements extends Component {
  render() {
    const { endorsements } = this.props;

    if (!endorsements || !endorsements.length) {
      return null;
    }

    return (
      <Row>
        <div>
          <Col xs={12} className="section-title">
            <h4>Endorsements</h4>
            {endorsements.map((endorsement, i) => (
              <FormGroup key={i} className="info-label-wrapper">
                <FormControlStatic>{endorsement.title}</FormControlStatic>
              </FormGroup>
            ))}
          </Col>
        </div>
        <div className="hr" />
      </Row>
    );
  }
}
